import React from "react";
import { render, screen } from "@testing-library/react";
import "@testing-library/jest-dom";
import ActionButtonProperties from "./ActionButtonProperties";

const mockAuthFetch = jest.fn();
jest.mock("../../../../../utils/useAuthFetch", () => ({
  useAuthFetch: () => mockAuthFetch,
}));
jest.mock("../../../hooks/useGroups", () => ({
  useGroups: () => ({ groups: [] }),
}));
jest.mock("../../../hooks/useCanvases", () => ({
  useCanvases: () => ({
    canvases: [{ id: "visible-canvas", name: "Visible canvas" }],
  }),
}));
jest.mock("../../../hooks/useViews", () => ({
  useViews: () => ({ views: [] }),
}));
jest.mock("../../RecipientPicker", () => () => <div>recipient picker</div>);

describe("ActionButtonProperties navigation", () => {
  beforeEach(() => mockAuthFetch.mockResolvedValue([]));

  it("marks a target absent from the actor-visible canvas list as unavailable", () => {
    render(
      <ActionButtonProperties
        workspaceId="workspace-1"
        props={{
          label: "Open",
          direct_action: {
            type: "NAVIGATE",
            config: {
              target_canvas_id: "hidden-canvas",
              record_source: "none",
            },
          },
        }}
        onChange={jest.fn()}
      />,
    );
    expect(
      screen.getByText("Selected destination is unavailable to you."),
    ).toBeInTheDocument();
    expect(screen.queryByText("hidden-canvas")).not.toBeInTheDocument();
  });
});
